module.exports = require("core-js-pure/features/get-iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/get-iterator.js
// module id = 615
// module chunks = 0